module.exports = __webpack_public_path__ + "img/5.01ae817.png";